import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { insertcomment, fetchcomments } from "../apis/api/FeedsApi";
import Loading from "../hooks/Loading";
import EmojiPicker from "emoji-picker-react";

const CommentArea = ({ id }) => {
  const dispatch = useDispatch();
  const [newComment, setNewComment] = useState("");
  const [comments, setcomments] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    fetchdata();
    const interval = setInterval(() => fetchdata(), 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
   
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false); 
      }
    };

   
    document.addEventListener("mousedown", handleClickOutside);

    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchdata = async () => {
    let response = await dispatch(fetchcomments({ post_id: id }));
    if (response && response.payload && response.payload.data) {
      setcomments(response.payload.data);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (newComment.trim()) {
      const currentTime = new Date();
      const timeString = currentTime.toLocaleTimeString();
      let member = Cookies.get("userId");
      let CompanyId = Cookies.get("company_id");
      member = JSON.parse(member);

      const newComments = {
        company_id: CompanyId,
        post_id: id,
        time: timeString,
        text: newComment,
      };
      dispatch(insertcomment(newComments));
      setNewComment("");
    }
  };

  const handleEmojiClick = (emojiData) => {
    setNewComment((prevComment) => prevComment + emojiData.emoji);
  };

  return (
    <>
      <Loading loading={comments.length === 0} />
      <div className="coment-area">
        <ul className="we-comet">
          {comments.length > 0 ? (
            comments.map((comment) => (
              <li key={comment.post_comment_id}>
                <div className="comet-avatar">
                  <img
                    className="Image"
                    src={comment.company_company_logo}
                    alt=""
                  />
                </div>
                <div className="we-comment">
                  <div className="coment-head">
                    <h5>
                      <a href="time-line.html" title="">
                        {comment.company_company_name}
                      </a>
                    </h5>
                    <span>{comment.post_comment_time}</span>
                    <a className="we-reply" href="#" title="Reply">
                      <i className="fa fa-reply"></i>
                    </a>
                  </div>
                  <p>{comment.post_comment_text}</p>
                </div>
              </li>
            ))
          ) : (
            <li>No comments available.</li>
          )}
        </ul>

        <div className="post-comt-box">
          <form method="post" onSubmit={handleSubmit}>
            <textarea
              placeholder="Post your comment"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              className="w-100 mb-2"
            ></textarea>

            <div className="d-flex justify-content-end position-relative">
              <button
                type="button"
                className="btn btn-primary btn-sm me-2"
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              >
                <i className="fa-regular fa-face-smile"></i>
              </button>

              {showEmojiPicker && (
                <div
                  ref={emojiPickerRef} 
                  className="position-absolute bottom-100 end-0 mb-2 z-index-10"
                >
                  <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
              )}

              <button type="submit" className="btn btn-primary btn-sm">
                <i className="fa-regular fa-paper-plane"></i> Comment
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CommentArea;
